import React, { useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

import { homeOrgs, departments, widerTeams, fullTimeEquivalents } from "../dropdowns";

/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const ProfileData = (props) => {
    const [widerTeam, setWiderTeam] = useState(props.user?.exts5qeux5w_WiderTeam?.WiderTeam);

    const changeDepartment = (event) => {
        setWiderTeam(widerTeams[event.currentTarget.value]);
    };

    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} xs={3} controlId="employeeID">
                    <Form.Label>Employee id</Form.Label>
                    <Form.Control type="text" required readOnly defaultValue={props.user?.employeeId} />
                </Form.Group>
                <Form.Group as={Col} xs={4} controlId="firstName">
                    <Form.Label>First name</Form.Label>
                    <Form.Control type="text" required readOnly defaultValue={props.user?.givenName} />
                </Form.Group>
                <Form.Group as={Col} controlId="lastName">
                    <Form.Label>Family name</Form.Label>
                    <Form.Control type="text" required readOnly defaultValue={props.user?.surname} />
                </Form.Group>
            </Row>
            <Row className="mb-2">
                <Form.Group as={Col} className="" controlId="phoneNumber">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control type="text" readOnly={!props.editable} defaultValue={props.user?.mobilePhone} />
                </Form.Group>
                <Form.Group as={Col} controlId="gender">
                    <Form.Label>Gender</Form.Label>
                    <Form.Select disabled={!props.editable} name="gender" size="sm" aria-label="Gender" defaultValue={props.user?.exts5qeux5w_WiderTeam?.gender}>
                        <option value=""></option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Female">Other</option>
                    </Form.Select>
                </Form.Group>
            </Row>
            <Row className="mb-2">
                <Form.Group as={Col} xs={5} controlId="homeOrg">
                    <Form.Label>Home Org</Form.Label>
                    <Form.Select disabled={!props.editable} name="homeOrg" required size="sm" aria-label="Home Org" defaultValue={props.user?.exts5qeux5w_WiderTeam?.HomeOrg}>
                        {homeOrgs.map(homeOrg => (
                            <option key={homeOrg.value} value={homeOrg.value}>{homeOrg.label}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
                <Form.Group as={Col} controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="text" required readOnly defaultValue={props.user?.mail} />
                </Form.Group>
            </Row>
            <Row className="mb-2">
                <Form.Group as={Col} xs={5} controlId="hiredOn">
                    <Form.Label>Hired on</Form.Label>
                    <Form.Control type="date" required pattern="\d{2}/\d{2}/\d{4}" readOnly={!props.editable} defaultValue={props.user?.employeeHireDate.split('T')[0]} />
                </Form.Group>
                <Form.Group as={Col} controlId="position">
                    <Form.Label>Position</Form.Label>
                    <Form.Control type="text" required readOnly={!props.editable} defaultValue={props.user?.jobTitle} />
                </Form.Group>
            </Row>
            <Row className="mb-2">
                <Form.Group as={Col} controlId="widerTeam">
                    <Form.Label>Wider team</Form.Label>
                    <Form.Control type="text" required readOnly value={widerTeam} />
                </Form.Group>
                <Form.Group as={Col} controlId="department">
                    <Form.Label>Department</Form.Label>
                    <Form.Select disabled={!props.editable} onChange={changeDepartment} name="department" required size="sm" aria-label="Department" defaultValue={props.user?.department}>
                        {departments.map(department => (
                            <option key={department.value} value={department.value}>{department.label}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Row>
            <Row className="mb-2">
                <Form.Group as={Col} controlId="emergencyContactName">
                    <Form.Label>Emergency Contact</Form.Label>
                    <Form.Control type="text" readOnly={!props.editable} defaultValue={props.user?.exts5qeux5w_WiderTeam?.emergencyContactName} />
                </Form.Group>
                <Form.Group as={Col} controlId="emergencyPhoneNumber">
                    <Form.Label>Emergency Phone</Form.Label>
                    <Form.Control type="text" readOnly={!props.editable} defaultValue={props.user?.exts5qeux5w_WiderTeam?.emergencyPhoneNumber} />
                </Form.Group>
            </Row>
            <Row className="mb-2">
                <Form.Group as={Col} xs={5} controlId="fullTimeEquivalents">
                    <Form.Label>Full Time Equivalents</Form.Label>
                    <Form.Select disabled={!props.editable} name="fullTimeEquivalents" required size="sm" aria-label="Full Time Equivalents" defaultValue={props.user?.exts5qeux5w_WiderTeam?.fullTimeEquivalents}>
                        {fullTimeEquivalents.map(fullTimeEquivalents => (
                            <option key={fullTimeEquivalents.value} value={fullTimeEquivalents.value}>{fullTimeEquivalents.label}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Row>
            {props.user?.exts5qeux5w_WiderTeam?.terminationDate && (
                <Row className="mb-2">
                    <Form.Group as={Col} xs={5} controlId="terminationDate">
                        <Form.Label>Leaving date</Form.Label>
                        <Form.Control type="date" pattern="\d{2}/\d{2}/\d{4}" readOnly={!props.editable} defaultValue={props.user?.exts5qeux5w_WiderTeam?.terminationDate.split('T')[0]} />
                    </Form.Group>
                    <Form.Group as={Col} controlId="terminationReason">
                        <Form.Label>Leaving reason</Form.Label>
                        <Form.Select disabled={!props.editable} name="reasonLeaving" size="sm" aria-label="Reason for leaving" defaultValue={props.user?.exts5qeux5w_WiderTeam?.terminationReasonDescription} >
                            <option value="Returning to Home Org">Returning to Home Org</option>
                            <option value="Resignation of employment">Resignation of employment</option>
                        </Form.Select>
                    </Form.Group>
                </Row>
            )}
            {props.editable && (
                <Button className="updateUser" variant="success" type="submit">Update</Button>
            )}
        </>
    );
};